<template lang="html">
  <v-form ref="form" lazy-validation>
    <v-card>
      <v-card-title>
        {{ `${$tc('label.usuario_fornecedor', 1)} - ${$tc('label.aprovador_autorizado', 1)}` }}
      </v-card-title>
      <usuario-fornecedor-dados-pessoais-form
        v-show="isPaginaCarregada"
        ref="usuarioFornecedorDadosPessoaisForm"
        :usuario="usuario"
        :encontrou-omni="encontrouOmni"
        :somente-leitura="somenteLeitura"
        :desabilitar-cadastro-fornecedor="desabilitarCadastroFornecedor"
        :is-somente-leitura-dados-sensiveis="isSomenteLeituraDadosSensiveis"
        :tenants-usuario="tenantsUsuario"
        @BuscarUsuarioOmni="buscarUsuarioOmni"
        @LimparFormulario="limparFormulario"
      >
      </usuario-fornecedor-dados-pessoais-form>
      <usuario-fornecedor-configuracoes-acesso-form
        v-show="isPaginaCarregada"
        ref="usuarioFornecedorConfiguracoesAcessoForm"
        :usuario="usuario"
        :encontrou-omni="encontrouOmni"
        :somente-leitura="somenteLeitura"
        :desabilitar-cadastro-fornecedor="desabilitarCadastroFornecedor"
        :is-somente-leitura-dados-sensiveis="isSomenteLeituraDadosSensiveis"
        :tenants-usuario="tenantsUsuario"
        :is-novo-cadastro="isNovoCadastro"
        :grupos-fornecedores="gruposFornecedores"
        :perfis="perfis"
        :usuario-logado="usuarioLogado"
        :ind-ativo-original="indAtivoOriginal"
        @BuscarGruposFornecedores="buscarGruposFornecedores"
      >
      </usuario-fornecedor-configuracoes-acesso-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="validarSalvar(true)"
          dark
          color="red"
          v-show="!isNovoCadastro && (usuario.dataVigenciaAExpirar || usuario.dataVigenciaExpirada || !indAtivoOriginal)">
          {{ $t('label.renovar_vigencia') }}
        </v-btn>
        <v-btn v-if="somenteLeitura" @click.native="cancel">{{ $t('label.voltar') }}</v-btn>
        <v-btn v-if="!somenteLeitura" @click.native="openCancelarDialog">{{ $t('label.cancelar') }}</v-btn>
        <v-btn v-if="!somenteLeitura" @click.native="validarSalvar(false)" color="primary">{{ $t('label.salvar') }}</v-btn>
      </v-card-actions>
    </v-card>

    <confirm
      ref="cancelarDialog"
      :title="$t('title.atencao')"
      :message="$t('message.tem_certeza_cancelar')"
      @agree="cancel">
    </confirm>

    <confirm
      ref="confirmDialog"
      :message="dialog.content"
      :persistent="true"
      @agree="dialog.action">
    </confirm>

    <usuario-form-termo-aceite-dialog
      v-if="termoAceite !== null && termoAceite.indAtivo"
      ref="termoAceiteDialog"
      :termo-aceite="termoAceite"
      @Finalizar="finalizar">
    </usuario-form-termo-aceite-dialog>
  </v-form>

</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import {
  forceHideLoading,
  forceLoading,
} from '@/common/functions/loading';
import Confirm from '@/shared-components/dialog/Confirm';
import Usuario from '@/spa/usuario/Usuario';
import UsuarioFormTermoAceiteDialog from '@/spa/usuario/UsuarioFormTermoAceiteDialog';
import UsuarioFornecedorDadosPessoaisForm from '@/spa/usuario/UsuarioFornecedorDadosPessoaisForm';
import UsuarioFornecedorConfiguracoesAcessoForm from '@/spa/usuario/UsuarioFornecedorConfiguracoesAcessoForm';
import { copyObject } from '@/common/functions/helpers';

export default {
  name: 'UsuarioFornecedorAprovadorAutorizadoForm',
  props: {
    somenteLeitura: Boolean,
    default: false,
  },
  components: {
    Confirm,
    UsuarioFornecedorDadosPessoaisForm,
    UsuarioFornecedorConfiguracoesAcessoForm,
    UsuarioFormTermoAceiteDialog,
  },
  computed: {
    ...mapGetters('implantacao', [
      'chaveEmpresa',
    ]),
    ...mapGetters('roles', [
      'getAllRoles',
      'getTenantId',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ...mapGetters('implantacao', [
      'indAmbienteProdutivo',
    ]),
    isTenantEpoca() {
      return this.getTenantId === 'epoca';
    },
    isNovoCadastro() {
      return !this.idUsuario && !this.usuario.id;
    },
    desabilitarCadastroFornecedor() {
      return this.isNovoCadastro && !this.buscouOmni;
    },
    isSomenteLeituraDadosSensiveis() {
      return (!this.isNovoCadastro || this.encontrouOmni) && this.tenantsUsuario && (this.tenantsUsuario.length > 1
      || (this.tenantsUsuario.length === 1 && this.tenantsUsuario[0].toUpperCase() !== this.chaveEmpresa));
    },
    usuarioLogadoFornecedor() {
      return this.usuarioLogado.tipo === 'FORNECEDOR';
    },
    usuarioLogadoFuncionario() {
      return this.usuarioLogado.tipo === 'FUNCIONARIO';
    },
    exigeTernoNomeacao() {
      if (this.usuarioLogadoFornecedor
        && (this.isNovoCadastro || this.indRenovaVigencia || this.mudouGrupoFornecedor())) {
        return true;
      }
      return false;
    },
    isGrupoFornecedorAlterado() {
      if (this.isNovoCadastro) {
        return false;
      }
      return this.mudouGrupoFornecedor();
    },
  },
  watch: {
  },
  data() {
    return {
      usuarioResource: this.$api.usuario(this.$resource),
      perfilResource: this.$api.perfil(this.$resource),
      extensaoResources: this.$api.extensao(this.$resource),
      termoAceiteResources: this.$api.termoAceite(this.$resource),
      gruposFornecedoresSelecionados: [],
      gruposFornecedores: [],
      perfis: [],
      listaIdsGruposComAceiteTernoNomeacao: [],
      idUsuario: null,
      termoAceite: null,
      usuarioSemEdicao: null,
      usuario: new Usuario(null, 'FORNECEDOR'),
      isPaginaCarregada: false,
      encontrouOmni: false,
      buscouOmni: false,
      tenantsUsuario: null,
      indRenovaVigencia: false,
      indAtivoOriginal: false,
      listaAceitesParaSalvar: [],
      idsDosGruposCarregados: [],
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action() {},
      },
    };
  },
  methods: {
    copyObject,
    ...mapActions('metadados', [
      'setUsuarioMetadado',
    ]),
    setarPaginaCarregada(indPaginaCarregada) {
      this.isPaginaCarregada = indPaginaCarregada;
    },
    validarSalvar(isRenovacao) {
      this.indRenovaVigencia = isRenovacao;
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.$refs.usuarioFornecedorConfiguracoesAcessoForm.listaGrupoFornecedores
        && !this.$refs.usuarioFornecedorConfiguracoesAcessoForm.listaGrupoFornecedores.length) {
        this.$toast(this.$t('message.grupo_fornecedor_obrigatorio'));
        return;
      }
      this.openSaveDialog();
    },
    openSaveDialog(ref, from) {
      const content = this.$t('message.salvar_usuario');
      this.setDialogContent(content, this.save, from || this.dialog.from);
      if (this.exigeTernoNomeacao) {
        this.verificaEAbreModalGruposPendenteAceiteTernoNomeacao();
      } else {
        this.$refs.confirmDialog.open();
      }
    },
    verificaEAbreModalGruposPendenteAceiteTernoNomeacao() {
      const listaAtual = this.$refs.usuarioFornecedorConfiguracoesAcessoForm.listaGrupoFornecedores || [];
      const gruposSelecionados = listaAtual;
      const idsOriginais = this.idsDosGruposCarregados ? this.idsDosGruposCarregados : [];
      let gruposPendentesAceite = [];

      const idsGruposRepLegal = this.usuarioLogado.idsGrupoFornecedor || [];

      const gruposSobMinhaAlcada = gruposSelecionados.filter((grupo) => idsGruposRepLegal.includes(grupo.id));

      if (this.indRenovaVigencia) {
        gruposPendentesAceite = gruposSobMinhaAlcada;
      } else {
        gruposPendentesAceite = gruposSobMinhaAlcada.filter((grupo) => {
          const isNovo = !idsOriginais.includes(grupo.id);
          const isLegadoPendente = idsOriginais.includes(grupo.id) && !this.listaIdsGruposComAceiteTernoNomeacao.includes(grupo.id);
          return isNovo || isLegadoPendente;
        });
      }

      if (gruposPendentesAceite.length > 0) {
        this.$refs.termoAceiteDialog.open(
          this.usuario.email,
          'razaoSocial',
          `${this.usuario.nome} ${this.usuario.sobrenome ? this.usuario.sobrenome : ''}`,
          gruposPendentesAceite,
        );
      } else {
        this.save();
      }
    },
    save() {
      this.aplicarTrimCamposTexto();

      const objArmazenamento = {
        ...this.usuario,
        tenant: this.getTenantId,
      };
      const lista = this.$refs.usuarioFornecedorConfiguracoesAcessoForm.listaGrupoFornecedores || [];
      const listaIdsGrupoFornecedor = lista.length > 0 ? lista.map((item) => parseInt(item.id, 10)) : [];

      if (this.indRenovaVigencia) {
        const hoje = this.moment();
        objArmazenamento.dtaInicioVigencia = hoje.format('YYYY-MM-DD');
        objArmazenamento.dtaFimVigencia = hoje.clone().add(1, 'year').format('YYYY-MM-DD');
        objArmazenamento.indAtivo = true;
      }

      objArmazenamento.indRenovaVigencia = this.indRenovaVigencia;
      objArmazenamento.indUsuarioExternoMaster = false;
      objArmazenamento.grupofornecedor = this.$refs.usuarioFornecedorConfiguracoesAcessoForm.listaGrupoFornecedores;
      objArmazenamento.id_grupofornecedor = listaIdsGrupoFornecedor;
      this.exibeAlertaLgpd();
      forceLoading();
      if (this.isNovoCadastro) {
        this.requestGravar(objArmazenamento, this.usuarioResource.gravar);
      } else {
        this.requestAtualizar(objArmazenamento, this.usuarioResource.atualizar);
      }
    },
    requestGravar(object, resource) {
      resource(object)
        .then((res) => {
          this.usuario.id = res.data;
          this.loginAntigo = '';
          if (this.exigeTernoNomeacao) {
            this.salvarTermoAceite();
          }
          window.setTimeout(() => {
            this.indCancelandoEdicao = false;
            forceHideLoading();
            this.$router.push({ name: 'usuario-fornecedor' });
            this.$toast(this.$t('message.adicionado_confira_tabela'));
          }, 500);
        })
        .catch((err) => {
          forceHideLoading();
          if (err.bodyText && JSON.parse(err.bodyText).erros
              && (JSON.parse(err.bodyText).erros[0] === 'login.duplicado'
                  || JSON.parse(err.bodyText).erros[0] === 'omni.usuario.nom_usuario.already_exists')) {
            this.loginAntigo = this.usuario.nomUsuario;
            this.$refs.form.validate();
          }
          this.$toast(err.data.error);
        });
    },
    requestAtualizar(object, resource) {
      resource({ id: object.id }, object)
        .then(() => {
          if (this.exigeTernoNomeacao) {
            this.salvarTermoAceite();
          }
          this.indCancelandoEdicao = false;
          forceHideLoading();
          window.setTimeout(() => {
            this.$router.push({ name: 'usuario-fornecedor' });
            this.$toast(this.$t('message.atualizado_com_sucesso'));
          }, 500);
        })
        .catch((err) => {
          forceHideLoading();
          this.$toast(err.data.error);
        });
    },
    finalizar(listaDeAceites) {
      this.listaAceitesParaSalvar = listaDeAceites;
      this.setDialogContent(null, this.save, this.dialog.from);
      this.$refs.confirmDialog.open();
    },
    salvarTermoAceite() {
      if (this.listaAceitesParaSalvar && this.listaAceitesParaSalvar.length > 0) {
        const payload = this.listaAceitesParaSalvar.map((item) => ({
          id_usuario_cadastrado: this.usuario.id,
          ind_aceito: item.indAceito,
          id: this.termoAceite.id,
          id_grupo_fornecedor: item.idGrupoFornecedor,
        }));
        this.termoAceiteResources.salvarListaAceiteCadastroUsuario(payload)
          .then(() => {
          })
          .catch((err) => {
            this.$toast(err.data.error);
          });
      } else if (this.termoAceite) {
        this.termoAceite.id_usuario_cadastrado = this.usuario.id;
        this.termoAceiteResources.salvarAceiteCadastroUsuario(this.termoAceite)
          .then().catch((err) => this.$toast(err.data.error));
      }
    },
    buscarTermoAceite() {
      const param = { objetivo: 'CRIACAO_USUARIO_FORNECEDOR' };
      this.termoAceiteResources.buscarTermoPorObjetivo(param).then((resposta) => {
        this.termoAceite = resposta.data;
      }, (err) => {
        this.$error(this, err);
      });
    },
    mudouGrupoFornecedor() {
      const listaAtual = this.$refs.usuarioFornecedorConfiguracoesAcessoForm.listaGrupoFornecedores || [];
      const listaOriginal = this.usuario.grupofornecedor || [];

      if (listaAtual.length !== listaOriginal.length) {
        return true;
      }

      const idsAtuais = listaAtual.map((item) => item.id).sort();
      const idsOriginais = listaOriginal.map((item) => item.id).sort();

      const saoIguais = idsAtuais.every((id, index) => id === idsOriginais[index]);

      return !saoIguais;
    },
    buscarUsuarioOmni() {
      const { tipo, email } = this.usuario;
      const filtro = { tipo, email };

      this.usuarioResource.buscarNoOmni(filtro)
        .then((res) => {
          const usuarioOmni = res.data;

          this.usuario.construirAPartirUsuarioOmni(usuarioOmni, false);
          const perfil = this.perfis.find((p) => p.idExterno === usuarioOmni.idPerfil);
          this.usuario.idPerfil = perfil ? perfil.id : null;
          this.tenantsUsuario = res.data.tenants.map((t) => t.tenant);
          this.usuario.indOrigemOmni = true;
          this.usuario.tipoFornecedor = this.$t('label.tipos_fornecedor.aprovador_autorizado');
          this.encontrouOmni = true;
          this.buscouOmni = true;
        })
        .catch((err) => {
          if (err.bodyText && JSON.parse(err.bodyText).erros
              && JSON.parse(err.bodyText).erros[0] === 'usuario.email_invalido') {
            this.buscouOmni = false;
            this.$error(this, err);
          } else {
            this.usuario.nomUsuario = this.usuario.email;
            this.usuario.tipoFornecedor = this.$t('label.tipos_fornecedor.aprovador_autorizado');
            this.buscouOmni = true;
            this.$error(this, err);
          }
        });
    },
    buscarPerfis(content = '') {
      const params = {
        autocomplete: content,
        limit: 100,
        page: 0,
      };
      return this.perfilResource.selecao(params)
        .then((res) => {
          if (res.data) {
            this.perfis = res.data.filter((perfil) => {
              perfil.indPerfilUsuarioExterno = this.converterStringParaBoolean(perfil.indPerfilUsuarioExterno);
              return perfil.indPerfilUsuarioExterno;
            });
          }
          this.selecionarPerfilAuto();
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    selecionarPerfilAuto() {
      if (this.usuarioLogadoFornecedor) {
        this.usuario.idPerfil = this.usuarioLogado.idPerfil;
      } else if (this.perfis.length === 1) {
        this.usuario.idPerfil = this.perfis[0].id;
      }
    },
    converterStringParaBoolean(perfil) {
      return (String(perfil).toLowerCase() === 'true');
    },
    buscarGruposFornecedores(idGrupoFornecedor = null, filtro = null) {
      let idsBusca = [];
      this.gruposFornecedoresSelecionados = [];
      if (Array.isArray(idGrupoFornecedor)) {
        idsBusca = idGrupoFornecedor;
      } else {
        idsBusca = idGrupoFornecedor ? [idGrupoFornecedor] : (this.usuarioLogado.idsGrupoFornecedor || []);
      }
      const value = {
        tamanhoPagina: 0,
        idNivelExtensao: 3,
        idsExtensao: idsBusca,
        autocomplete: filtro,
      };
      return this.extensaoResources.listarAtivosComListaCnpj(value)
        .then((resultado) => {
          resultado.body.resposta.forEach((el) => {
            let nomGrupoFornecedor = el.id.toString().concat(' - ').concat(el.idExterno);
            if (this.isTenantEpoca) {
              nomGrupoFornecedor = el.idExterno.toString().concat(' - ').concat(el.nomExtensao);
            }
            const item = {
              ...el,
              id: el.id,
              nome: nomGrupoFornecedor,
              indPossuiRepresentacaoConjunto: el.indPossuiRepresentacaoConjunto,
            };
            this.gruposFornecedores.push(item);
            if (idGrupoFornecedor && idGrupoFornecedor.length) {
              idGrupoFornecedor.forEach((id) => {
                if (id === item.id) {
                  this.gruposFornecedoresSelecionados.push(item);
                }
              });
            }
          });
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    carregarUsuario(id) {
      this.usuarioResource.buscar({ id })
        .then((res) => {
          const usuario = res.body;
          this.indAtivoOriginal = usuario.indAtivo;
          this.idsDosGruposCarregados = usuario.idGrupoFornecedor ? usuario.idGrupoFornecedor.split(',').map((idGrupo) => Number(idGrupo.trim())) : [];
          this.buscarGruposFornecedores(this.idsDosGruposCarregados).then(() => {
            this.editar(usuario);
            this.tenantsUsuario = usuario.tenant?.split(',').map((t) => t.trim()) ?? [];
            forceHideLoading();
          });
          this.buscarAceitesExistentes(id, this.idsDosGruposCarregados);
        })
        .catch((err) => {
          this.$error(this, err);
          forceHideLoading();
        });
    },
    editar(usuario) {
      this.usuario = new Usuario();
      this.usuario.construirAPartirDaConsultaCompleta({ ...usuario });
      this.usuario.grupofornecedor = this.gruposFornecedoresSelecionados;
      this.usuario.tipoFornecedor = this.$t('label.tipos_fornecedor.aprovador_autorizado');
      if (this.gruposFornecedoresSelecionados.length) {
        this.gruposFornecedoresSelecionados.forEach((el) => {
          this.$refs.usuarioFornecedorConfiguracoesAcessoForm.incluirLinhaGrupoFornecedor(el.id);
        });
      }
      this.usuarioSemEdicao = copyObject(usuario);
    },
    buscarAceitesExistentes(idUsuario, idsGruposCadastrados) {
      const params = {
        idUsuario,
        tipoTermo: 'termoNomeacao',
        tipoUsuario: 'APROVADOR_AUTORIZADO',
        idsGruposCadastrados,
      };

      this.termoAceiteResources.buscarAceitesUsuarioPorGrupo(params)
        .then((response) => {
          const aceites = response.data || [];
          this.listaIdsGruposComAceiteTernoNomeacao = aceites
            .map((a) => a.id_grupo_fornecedor)
            .filter((id) => id !== null && id !== undefined);
        })
        .catch((err) => {
          console.error('Erro ao buscar aceites existentes', err);
        });
    },
    aplicarTrimCamposTexto() {
      this.usuario.nomUsuario = this.usuario.nomUsuario.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
      this.usuario.email = this.usuario.email.trim();
      this.usuario.nome = this.usuario.nome.trim();
      if (this.usuario.matricula) {
        this.usuario.matricula = this.usuario.matricula.trim();
      }
      if (this.usuario.sobrenome) {
        this.usuario.sobrenome = this.usuario.sobrenome.trim();
      }
      if (this.usuario.cargo) {
        this.usuario.cargo = this.usuario.cargo.trim();
      }
      if (this.usuario.documento) {
        this.usuario.documento = this.usuario.documento.trim();
      }
    },
    limparFormulario() {
      this.usuario = new Usuario(null, 'FORNECEDOR');
      this.encontrouOmni = false;
      this.tenantsUsuario = null;
      this.$refs.form.reset();
    },
    cancel() {
      this.limparFormulario();
      this.$router.push({ name: 'usuario-fornecedor' });
    },
    openCancelarDialog() {
      this.$refs.cancelarDialog.open();
    },
    exibeAlertaLgpd() {
      if (this.indAmbienteProdutivo) return;

      const alertaLgpd = this.$t('message.lgpd');
      alert(alertaLgpd); // eslint-disable-line
    },
    setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_usuario');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
  },
  mounted() {
    forceLoading();
    const idGrupoFornecedorCarregado = this.usuarioLogadoFornecedor ? this.usuarioLogado.idGrupoFornecedor : null;
    Promise.all([
      this.buscarGruposFornecedores(idGrupoFornecedorCarregado),
      this.buscarPerfis(),
      this.buscarTermoAceite(),
    ]).then(() => {
      if (this.$route.params.id) {
        this.indCancelandoEdicao = false;
        this.idUsuario = parseInt(this.$route.params.id, 10);
        Promise.all([
          this.carregarUsuario(this.idUsuario),
        ]).then(() => this.setarPaginaCarregada(true));
      } else {
        this.setarPaginaCarregada(true);
        forceHideLoading();
      }
    });
  },
};
</script>
<style scoped>

</style>
